<script setup lang="ts">

withDefaults(defineProps<{
        color?: string,
        thumbColor?: string,
        isLoading: boolean,
    }>(),
    {color: "primary", thumbColor: "#3513e2"});

const on = defineModel<boolean>();

</script>

<template>
  <v-switch
    v-model="on"
    label=""
    class="h-14"
    :color="color"
    inset
    :disabled="isLoading"
    :loading="isLoading"
    @update:model-value="on = !!$event"
  />
</template>

<!--
  Scoped so the extra attribute outweighs Vuetify's own inset rules whatever
  the order the stylesheets load in, and so other switches keep Vuetify's look.
-->
<style scoped>
.v-switch--inset :deep(.v-switch__track) {
    height: 15px;
    min-width: 35px;
    background-color: #e3e3e3;
}

.v-switch--inset :deep(.v-switch__thumb) {
    background-color: #a8a8a8;
    width: 15px;
    height: 15px;
}

.v-switch--inset :deep(.v-selection-control--dirty .v-switch__thumb) {
    background-color: v-bind('thumbColor');
}

.v-switch--inset :deep(.v-switch__thumb) {
    transform: scale(1);
}
</style>